import React from "react"
import { useAppDispatch } from "integrations/redux/hooks"
import { ButtonInlineIcon } from "@nova/component-btn"
import * as Icons from "@nova/component-icons"
import { copyState } from "features/pubsub/slice"
import { Tooltip } from "../Tooltip"

export const CopyButton = () => {
    const dispatch = useAppDispatch()

    return (
        <Tooltip
            message="Replicate map state"
            messageClasses="!bottom-[-37px] left-[-85px] pointer-events-none text-gray-900"
            light
        >
            <ButtonInlineIcon icon={Icons.Copy} onClick={() => dispatch(copyState())} />
        </Tooltip>
    )
}
